import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { FirebaseStorageService } from './firebase-storage.service';
import { availableAffiliations } from '../constants/constants';

@Injectable({
  providedIn: 'root'
})
export class AffiliationService {
  private affiliationsSubject = new BehaviorSubject<typeof availableAffiliations>(
    availableAffiliations.map(affiliation => ({ ...affiliation }))
  );
  affiliations$ = this.affiliationsSubject.asObservable();

  constructor(private firebaseStorage: FirebaseStorageService) {
    this.initializeAffiliations();
  }

  private async initializeAffiliations() {
    const logoUrls = await this.firebaseStorage.getLogoUrls();
    
    // Klónozzuk az eredeti affiliációkat
    const affiliations = JSON.parse(JSON.stringify(availableAffiliations));

    // Frissítjük a logó URL-eket a környezetnek megfelelően
    affiliations.forEach((affiliation: { value: string; logo: string; }) => {
      if (affiliation.value === 'other' || affiliation.logo.startsWith('assets/')) return;

      const filename = affiliation.logo.split('/').pop()?.split('?')[0];
      if (filename) {
        const decodedFilename = decodeURIComponent(filename);
        affiliation.logo = logoUrls.get(decodedFilename) || affiliation.logo;
      }
    });

    this.affiliationsSubject.next(affiliations);
  }

  getAffiliations(): typeof availableAffiliations {
    return this.affiliationsSubject.value;
  }
}
